import { render, staticRenderFns } from "./AnswerPage.vue?vue&type=template&id=f8724f12&"
import script from "./AnswerPage.vue?vue&type=script&lang=js&"
export * from "./AnswerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports